import {
  Button,
  ButtonProps,
  StatusIndicator,
} from '@cloudscape-design/components';
import { useState } from 'react';

import { UpgradeAssessmentStatus } from 'api/admin-models';

export function UpgradeAssessmentBadgeStatus({
  value,
}: {
  value: UpgradeAssessmentStatus;
}): JSX.Element {
  if (value === 'pending') {
    return <StatusIndicator type="warning">{value}</StatusIndicator>;
  } else if (value === 'in-progress') {
    return <StatusIndicator type="in-progress">{value}</StatusIndicator>;
  } else if (value === 'ready') {
    return <StatusIndicator type="success">{value}</StatusIndicator>;
  } else if (value == 'failed') {
    return <StatusIndicator type="error">{value}</StatusIndicator>;
  } else if (value == 'archived') {
    return <StatusIndicator type="stopped">{value}</StatusIndicator>;
  } else if (value == 'outdated') {
    return <StatusIndicator type="warning">{value}</StatusIndicator>;
  } else {
    return <>{value}</>;
  }
}

export function TemporalBadgeStatus({
  value,
}: {
  value?: string;
}): JSX.Element {
  if (value === undefined || value === '') {
    return <StatusIndicator type="pending">Not created</StatusIndicator>;
  } else if (value === 'Terminated') {
    return <StatusIndicator type="error">{value}</StatusIndicator>;
  } else {
    return <StatusIndicator type="info">{value}</StatusIndicator>;
  }
}

export interface ActionButtonProps extends ButtonProps {
  onConfirm?: () => Promise<void>;
}

export function ActionButton({
  onConfirm,
  ...otherProps
}: ActionButtonProps): JSX.Element {
  const [loading, setLoading] = useState(false);
  const handleClick = async () => {
    setLoading(true);
    try {
      if (onConfirm !== undefined) {
        await onConfirm();
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <Button
      loading={loading}
      onClick={() => void handleClick()}
      {...otherProps}
    />
  );
}
